// StudyMaterialsPage.tsx

import { Typography, Container, Box, Stack, Chip, Alert } from "@mui/material";
import { HourglassEmpty, Autorenew } from "@mui/icons-material";

const StudyMaterialsPage = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 16 }}>
      <Box
        sx={{
          bgcolor: "background.paper",
          pt: { xs: 6, md: 10 },
          pb: { xs: 6, md: 8 },
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Container maxWidth="md">
          <Stack sx={{ alignItems: "center", textAlign: "center", gap: 3 }}>
            <Chip
              icon={<Autorenew sx={{ animation: "spin 2s linear infinite" }} />}
              label="Live Catalog Compilation in Progress"
              color="warning"
              variant="outlined"
              sx={{ px: 1.5, py: 0.75, fontWeight: 600, borderRadius: 1 }}
            />
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "2.25rem", md: "3.5rem" },
                letterSpacing: "-0.02em",
                color: "text.primary",
              }}
            >
              Study Materials
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400, maxWidth: "650px", lineHeight: 1.6 }}>
              We are actively compiling, verifying, and formatting our community partners' study notes.
            </Typography>

            <Box id="notify-section" sx={{ width: "100%", maxWidth: "520px", pt: 2 }}>
              <Alert
                icon={<HourglassEmpty fontSize="inherit" />}
                severity="info"
                sx={{ textAlign: "left", borderRadius: 1, mb: 3 }}
              >
                Resources are refreshing monthly.
              </Alert>
            </Box>
          </Stack>
        </Container>
      </Box>

      {/* Listing Pipeline Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
            mb: 4,
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 700, color: "text.primary" }}>
              Upcoming Material Categories
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Real-time transparency on our content generation pipeline.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Container>
  );
};

export default StudyMaterialsPage;
